import { render } from "./ImageGridBase.vue?vue&type=template&id=21e9977d&scoped=true"
import script from "./ImageGridBase.vue?vue&type=script&lang=js"
export * from "./ImageGridBase.vue?vue&type=script&lang=js"

import "./ImageGridBase.vue?vue&type=style&index=0&id=21e9977d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21e9977d"

export default script